export default __webpack_public_path__ + "static/media/forgot-screen-bg-img.f0687621.svg";